import { useEffect, useRef } from 'react';
import { API } from './globalUtils';
import useDataStore from './Data/dataStore';
import usePageStore from './Page/pageStore';
import { useLocation } from 'react-router-dom';
import { detectBlog, detectProducts, getPath } from './Router/Router';
import { blogListKey, errorPage, fetchContent, fetchPath, } from '../sharedFetchUtils';
/**
 * Runs `task` after the page has finished loading, once the main thread is
 * free. Falls back to a short timeout where requestIdleCallback is missing.
 */
const whenIdle = (task) => {
    const schedule = () => {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(task, { timeout: 3000 });
        }
        else {
            window.setTimeout(task, 200);
        }
    };
    if (document.readyState === 'complete')
        schedule();
    else
        window.addEventListener('load', schedule, { once: true });
};
const WordpressDispatcher = () => {
    const location = useLocation().pathname;
    const { activePage } = usePageStore();
    const mounted = useRef(false);
    useEffect(() => {
        fetchBaseContent();
    }, []);
    useEffect(() => {
        if (activePage === errorPage) {
            //TODO: show errorPage;
            return;
        }
        const isBlog = detectBlog(location);
        if (isBlog && !useDataStore.getState().data[getPath(location)]) {
            // try to fetch blog
            fetchPath(getPath(location), useDataStore.getState().setData, false, true);
        }
    }, [activePage]);
    const fetchBaseContent = async () => {
        if (mounted.current)
            return;
        mounted.current = true;
        const originPath = getPath(location);
        const isBlog = detectBlog(location);
        const isProduct = detectProducts(location);
        const { setData, setFirstFetch } = useDataStore.getState();
        const fetchCurrentPage = () => {
            fetchPath(originPath, setData, isProduct, isBlog);
            if (isBlog) {
                fetchPath(API.blog, setData);
            }
        };
        // Two things are genuinely not in the static snapshot and so cannot wait:
        //
        //  - this page, when it is a blog post or any deep link the snapshot has no
        //    entry for -- there is nothing at all to render until it lands;
        //  - the blog list, which the snapshot never carries. getAllNews() returns
        //    an empty array without it, so the news sections stay blank until it
        //    arrives.
        const alreadyHaveThisPage = !!useDataStore.getState().data[originPath];
        if (!alreadyHaveThisPage)
            fetchCurrentPage();
        fetchPath(blogListKey, setData, false, false, true);
        // The rest is a refresh of content the snapshot already supplied. It used
        // to fire ~23 further requests during load, each resolving into the store
        // while the page was still painting. Deferring costs nothing visible: an
        // edit made in WordPress still appears on this same page view, just after
        // the page is interactive rather than in competition with it.
        whenIdle(() => {
            if (alreadyHaveThisPage)
                fetchCurrentPage();
            fetchContent(setData, setFirstFetch);
        });
    };
    return null;
};
export default WordpressDispatcher;
